<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" fab depressed small>
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-form ref="formContact" v-model="valid" lazy-validation>
        <v-toolbar flat>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{
            $t("profileDialogContactTitle")
          }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-alert :type="alertType" border="left" text dense>
            {{ alertMessage }}
          </v-alert>

          <v-form v-model="validPhoneForm" lazy-validation>
            <v-text-field
              v-model="newPhone"
              v-mask="mask"
              :rules="[rules.required, rules.phoneCounter]"
              :label="$t('profileDialogContactPhone')"
              type="string"
              outlined
              required
              :loading="validatePhoneLoading"
              :error="phoneError"
              :error-messages="phoneErrorMessage"
              v-on="$isCreditOnline() ? { change: validatePhone } : {}"
            ></v-text-field>

            <div class="d-flex mb-4">
              <v-btn
                class="ml-auto"
                depressed
                color="primary"
                type="submit"
                @click.prevent="editContact('phone')"
                :disabled="!validPhoneForm || phoneLoading || emailLoading || phoneNotChanged"
                :loading="phoneLoading"
              >
                {{ $t("BtnSave") }}
              </v-btn>
            </div>
          </v-form>

          <v-form v-model="validEmailForm" class="pt-4" lazy-validation>
            <v-alert type="info" border="left" text dense>
              {{ $t("changeContactInfo.loginChangeAfterEmailChange") }}
            </v-alert>

            <v-text-field
              v-model="contact.email"
              :label="$t('profileDialogContactEmail')"
              outlined
              :rules="[rules.validEmail, rules.validEmailDomain]"
              type="email"
              required
            ></v-text-field>

            <div class="d-flex">
              <v-btn
                class="ml-auto"
                depressed
                color="primary"
                type="submit"
                @click.prevent="editContact('email')"
                :disabled="!validEmailForm || emailLoading || phoneLoading || emailNotChanged"
                :loading="emailLoading"
              >
                {{ $t("BtnSave") }}
              </v-btn>
            </div>
          </v-form>
        </v-card-text>

        <!-- <v-card-actions class="pa-5">
          <div class="flex-grow-1"></div>
          <v-btn text outlined="" @click="dialog = false">
            {{ $t("BtnCancel") }}
          </v-btn>
          <v-btn
            depressed
            color="primary"
            type="submit"
            @click.prevent="editUser"
            :disabled="!valid"
            :loading="loading"
          >
            {{ $t("BtnSave") }}
          </v-btn>
        </v-card-actions> -->
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import qs from "qs"; // convert obj in "x-www-form-urlencoded format".
import { validate } from "@/util/form-validate.js";

export default {
  name: "dialogEditContact",
  props: ["contact"],
  data: () => ({
    dialog: false,
    dialogTitle: "Dados de Contato",
    phoneLoading: false,
    emailLoading: false,
    valid: false,
    mask: "",

    // Rules Default Import
    rules: {
      required: validate.required,
      phoneCounter: validate.phoneCounterMask,
      max: validate.max,
      validEmail: validate.validEmail,
      validEmailDomain: validate.validateEmailDomain,
    },
    phoneError: false,
    phoneErrorMessage: "",
    validatePhoneLoading: false,
    newPhone: "",
    validPhoneForm: false,
    validEmailForm: false,

    alertType: "info",
    alertMessage: "Após a mudança, um Email ou SMS será enviado para você com um link de confirmação.",

    oldData: {
      phone: "",
      email: "",
    }
  }),
  mounted() {
    this.newPhone = this.contact.celular;
    this.oldData = {
      phone: this.contact.celular,
      email: this.contact.email,
    };
  },
  watch: {
    dialog(val) {
      !val && this.$emit("refresh-user");
    },
    "contact.celular"(val) {
      this.newPhone = val;
    },
    newPhone() {
      this.mask = "(##)#####-####";
    },
  },
  computed: {
    phoneNotChanged() {
      if (this.newPhone && this.oldData.phone) {
        const newPhone = 
          this.newPhone.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi, "");
        const oldPhone = 
          this.oldData.phone.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi, "");
  
        return newPhone === oldPhone;
      }

      return false;
    },
    emailNotChanged() {
      return this.contact.email === this.oldData.email;
    },
  },
  methods: {
    validatePhone() {
      const phone = this.newPhone.replace(
        /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
        ""
      );

      if (phone.length != 11) {
        return;
      }

      this.validatePhoneLoading = true;

      const body = { phone, domain: this.$domain() };
      this.$axios
        .post("/player/online/register/validatePhone", this.$formdata(body))
        .then(() => {
          this.phoneError = false;
          this.phoneErrorMessage = "";
        })
        .catch((err) => {
          this.phoneError = true;
          this.phoneErrorMessage = err.response.data.messages.error;
        })
        .finally(() => {
          this.validatePhoneLoading = false;
        });
    },

    editContact(type) {
      const body = {
        domain: this.$domain(),
      };

      if (type === "phone") {
        body.phone = this.newPhone.replace(
          /[`~!@#$%^&*()_|+\-=?;:'",.<>/( )+/\{\}\[\]\\\/]/gi,
          ""
        )
        this.phoneLoading = true;
      } else {
        body.email = this.contact.email;
        this.emailLoading = true;
      }

      this.$axios.post("/player/profile/changeContactIntention", this.$formdata(body))
        .then((res) => {
          this.alertType = "success";
          this.alertMessage = res.data.messages;
          this.phoneLoading = false;
          this.emailLoading = false;
        }).catch((err) => {
          this.alertType = "error";
          this.alertMessage = err.response.data.messages.error;
          this.phoneLoading = false;
          this.emailLoading = false;
        });
    },
  },
};
</script>
